// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3i6Vb","content":"styles_content__29tA3","selectAll":"styles_selectAll__1_VSp"};